import { render, staticRenderFns } from "./Checkin.vue?vue&type=template&id=644b80db&lang=pug"
import script from "./Checkin.vue?vue&type=script&lang=js"
export * from "./Checkin.vue?vue&type=script&lang=js"
import style0 from "./Checkin.vue?vue&type=style&index=0&id=644b80db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports